import React, { FC, Fragment } from 'react';
import { MutationFunction } from 'react-apollo';
import { some } from 'lodash';

import { useCreateReactionMutation, useDeleteReactionMutation } from 'api';
import { Heart } from 'components';
import { createReactionResponse, deleteReactionResponse } from 'apollo/responses';

import { content as contentReducer } from 'apollo/reducers';
import { useContent, useCurrentUser, useNotify } from 'hooks';

const Reactions: FC = () => {
  const content = useContent();
  const currentUser = useCurrentUser();
  const notify = useNotify();
  const [createReaction] = useCreateReactionMutation({
    onError: notify.mutationError,
  });
  const [deleteReaction] = useDeleteReactionMutation({
    onError: notify.mutationError,
  });

  const { content_id, reacted_by } = content;
  const isLiked = some(reacted_by, { id: currentUser.id });

  function handleClick() {
    const optimisticResponse = isLiked ? deleteReactionResponse() : createReactionResponse();
    const mutation: MutationFunction = isLiked ? deleteReaction : createReaction;

    return mutation({
      variables: { content_id },
      optimisticResponse,
      update: cache => {
        const name = isLiked ? 'deleteReaction' : 'createReaction';
        contentReducer({ name, cache, id: content_id, data: { profile: currentUser } });
      },
    });
  }

  function renderReactions() {
    return <Heart active={isLiked} onClick={handleClick} />;
  }

  return <Fragment>{renderReactions()}</Fragment>;
};

export default Reactions;
